import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@/shared/query-client/query-client";
import { createTicketsFromCandidates } from "@/shared/actions/campanas/migracion.actions";
// Tipos centralizados en types/migracion.interface para evitar duplicado
// (TS2308 al re-exportar `* from './hooks'` y `* from './types'` desde el
// barrel index). NO se re-exportan desde aqui: los consumidores deben
// importarlos desde "@/erp/campanas/migracion" (barrel) o desde "../types".
import type {
  CreateTicketsFromCandidatesRequest,
  CreateTicketsFromCandidatesResponse,
} from "../types/migracion.interface";

export const useCreateTicketsFromCandidates = () => {
  const mutation = useMutation<
    CreateTicketsFromCandidatesResponse,
    Error,
    CreateTicketsFromCandidatesRequest
  >({
    mutationFn: async (payload) => {
      const response: any = await createTicketsFromCandidates(payload);

      return {
        successCount: response?.successCount ?? response?.data?.successCount ?? 0,
        errorCount: response?.errorCount ?? response?.data?.errorCount ?? 0,
        totalRequested:
          response?.totalRequested ?? response?.data?.totalRequested ?? 0,
        errors: response?.errors ?? response?.data?.errors ?? [],
      };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["obsolete-candidates"],
      });

      queryClient.invalidateQueries({
        queryKey: ["migration-uploads"],
      });
    },
  });

  return {
    createTickets: mutation.mutateAsync,
    loading: mutation.isPending,
  };
};